/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CostAppraisalProductResponseDto } from './costAppraisalProductResponseDto';

export interface CostAppraisalResponseDto {
  createdUserId: string;
  createdUsername: string;
  createdAt: Date;
  updatedUserId: string;
  updatedUsername: string;
  updatedAt: Date;
  deletedUserId: string;
  deletedUsername: string;
  deletedAt: Date;
  id: string;
  /**
   * 2021-10-01T00:00:00Z
   */
  effectiveDate: string;
  status: CostAppraisalResponseDto.StatusEnum;
  costAppraisalProducts: Array<CostAppraisalProductResponseDto>;
}
// tslint:disable-next-line:no-namespace
export namespace CostAppraisalResponseDto {
  export type StatusEnum = 'draft' | 'active' | 'in_active';
  export const StatusEnum = {
      Draft: 'draft' as StatusEnum,
      Active: 'active' as StatusEnum,
      InActive: 'in_active' as StatusEnum,
  };
}
